module.exports = __webpack_public_path__ + "static/corn-6f53705f75ce20271229775f09168f74.png";